import { render, staticRenderFns } from "./ManageComVoucher.vue?vue&type=template&id=63dd7240&"
import script from "./ManageComVoucher.vue?vue&type=script&lang=js&"
export * from "./ManageComVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports